import Vue from 'vue'
import VueRouter from 'vue-router'
import Search from '@/views/Search/Search'
import Login from '@/views/Login'
import Profile from '@/views/Profile/Profile'
import error403 from '@/views/403'
import error404 from '@/views/404'
import LoggedOut from '@/views/LoggedOut'
import EmployerInfo from '@/views/EmployerInfo'
import Contact from '@/views/Contact'
import AboutJobskills from '@/views/AboutJobskills'
import { requireToken } from './navigationGuards'

Vue.use(VueRouter)

export default new VueRouter({
  base: window.__BASE__,
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/sok',
      name: 'Sök',
      component: Search,
      beforeEnter: requireToken
    },
    {
      path: '/profile/:id',
      name: 'Profile',
      component: Profile,
      beforeEnter: requireToken
    },
    {
      path: '/403',
      name: '403',
      component: error403
    },
    {
      path: '/logged-out',
      name: 'logout',
      component: LoggedOut
    },
    {
      path: '/arbetsgivarinformation',
      name: 'EmployerInfo',
      component: EmployerInfo
    },
    {
      path: '/kontakta-oss',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/om-jobskills',
      name: 'AboutJobskills',
      component: AboutJobskills
    },
    {
      path: '*',
      name: '404',
      component: error404
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js